import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosControl} from '../../../core/visbos-core/ui/forms/abstract-visbos-control';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FORM_ERROR_MESSAGES} from '../../../core/visbos-core/assets/form-error-messages';
import {SessionActions} from '../../../shared/actions';
import {ErrorHandlerService} from '../../../core/visbos-core/error-handling/error-handler.service';
import {appInjector} from '../../../index';
import {Account} from '../../../shared/view-model/crm/account.type';
import {AccountingUnitService} from '../../services/accounting-unit.service';

@Component({
  selector: 'vb-account-form',
  templateUrl: './account-form.component.html',
  styleUrls: ['./account-form.component.css']
})
export class AccountFormComponent extends AbstractVisbosControl<Account, FormGroup> implements OnInit {

  errorDefs = FORM_ERROR_MESSAGES;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions, private errorHandler: ErrorHandlerService,
              private accountService: AccountingUnitService) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(values?: Account, ...params): FormGroup {
    return AccountFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [AccountFormComponent.cuid()],
      account_number: [null, Validators.required],
      clearing_account_number: [null],
      account_name: [null]
    });

  }

  public setDefaultValues(item?: Account): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AccountFormComponent.cuid()),
      account_number: this.setValue(item, 'account_number'),
      clearing_account_number: this.setValue(item, 'clearing_account_number'),
      account_name: this.setValue(item, 'account_name')
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/components/account-form/account-form.component.ts